import React from 'react';
import { RouteObject } from 'react-router-dom';
import { Settings } from './Settings';
import { Security } from './routes/Security';
import { ChangePassword } from './routes/ChangePassword';

export const settingsRoutes: RouteObject[] = [
  {
    path: '',
    element: <Settings />,
  }, {
    path: 'security',
    children: [
      {
        path: '',
        element: <Security />,
      }, {
        path: 'change-password',
        element: <ChangePassword />,
      },
    ],
  },
];
